import { RouterProvider } from '@tanstack/react-router';
import { useState, type ReactNode } from 'react';

import { Providers } from './providers';
import { createQueryClient } from './query-client';
import { createAppRouter } from './router';

/**
 * The whole application: one QueryClient, one router, one provider stack. Both are created once
 * — a QueryClient rebuilt on re-render throws away every cache entry, which looks like a
 * performance problem and is really a lifecycle bug.
 */
export function App(): ReactNode {
  const [queryClient] = useState(createQueryClient);
  const [router] = useState(() => createAppRouter(queryClient));

  return (
    <Providers queryClient={queryClient}>
      <RouterProvider router={router} />
    </Providers>
  );
}
